import React from 'react';
import { Steps } from 'antd';
import styled from 'styled-components';
import { Step } from '../../services/util/step-manager/types/Step';
import StepManager from '../../services/util/step-manager/StepManager';

const CustomStep = styled(Steps)`
  .ant-steps-item:nth-child(${props => (props.current || 0) + 1}) .ant-steps-item-container {
    font-weight: bold;
  }
`;

type Props = {
  currentStep: Step;
  onChangeStep: (selectedStep: number) => void;
};

const CustomSteps: React.FC<Props> = ({ currentStep, onChangeStep }) => {
  return (
    <>
      <CustomStep
        current={currentStep.order}
        progressDot
        onChange={onChangeStep}
        size="small"
        style={{ marginBottom: '32px', width: '675px' }}
        items={StepManager.getStepsForUI()}
      />
    </>
  );
};

export default CustomSteps;
